import KatalLogger, {Level} from "@amzn/katal-logger";
import {isLoginMode, isWidget} from "src/config/Config";

const loggerConfig = {
    url: '/rc/logger',
    context: {
        "client": isWidget() ? "IRC" : (isLoginMode() ? "RC" : "Public")
    },
    logToConsole: false,
    logThreshold: Level.INFO,
    maxLogLineSize: 10000
}

export const logger = new KatalLogger(loggerConfig);
logger.addErrorListener();
